import Vue from 'vue'
import Swal from 'vue-sweetalert2'
export default () => {
  Vue.use(Swal)
}
